(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ii-abaya-reviews"] && !Shopify.designMode) return;
  try {
    
  function initialiseProductReviews(root = document) {
    root.querySelectorAll('[data-ii-reviews]').forEach((section) => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const writer = section.querySelector('.ii-review-writer');
      const form = section.querySelector('.ii-review-form');
      const cards = Array.from(section.querySelectorAll('[data-review-card]'));
      const more = section.querySelector('[data-review-more]');
      const openFromLink = () => {
        if (location.hash === '#ReviewForm' || (form && location.hash === '#' + form.id)) {
          writer.open = true;
          writer.scrollIntoView({ block: 'start' });
        }
      };
      openFromLink();
      window.addEventListener('hashchange', openFromLink);
      if (section.querySelector('[data-review-result]') && writer.open) {
        section.querySelector('[data-review-result]').focus({ preventScroll: true });
      }
      if (form) form.addEventListener('invalid', () => { writer.open = true; }, true);
      if (more) {
        let visibleCount = 5;
        cards.forEach((card, index) => { card.hidden = index >= visibleCount; });
        more.hidden = false;
        more.addEventListener('click', () => {
          const nextCard = cards[visibleCount];
          visibleCount += 5;
          cards.forEach((card, index) => { card.hidden = index >= visibleCount; });
          if (nextCard) {
            nextCard.tabIndex = -1;
            nextCard.focus({ preventScroll: true });
          }
          more.hidden = visibleCount >= cards.length;
        });
      }
    });
  }
  initialiseProductReviews();
  document.addEventListener('shopify:section:load', (event) => initialiseProductReviews(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ii-bakhoor-reviews"] && !Shopify.designMode) return;
  try {
    
  function initialiseHM20Reviews(root = document) {
    root.querySelectorAll('[data-ii-hm20-reviews]').forEach((section) => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const writer = section.querySelector('.ii-hm20-review-writer');
      const form = section.querySelector('.ii-hm20-review-form');
      const cards = Array.from(section.querySelectorAll('[data-review-card]'));
      const more = section.querySelector('[data-review-more]');
      const openFromLink = () => {
        if (location.hash === '#HM20ReviewForm' || (form && location.hash === '#' + form.id)) {
          writer.open = true;
          writer.scrollIntoView({ block: 'start' });
        }
      };
      openFromLink();
      window.addEventListener('hashchange', openFromLink);
      if (section.querySelector('[data-review-result]') && writer.open) {
        section.querySelector('[data-review-result]').focus({ preventScroll: true });
      }
      if (form) form.addEventListener('invalid', () => { writer.open = true; }, true);
      if (more) {
        let visibleCount = 5;
        cards.forEach((card, index) => { card.hidden = index >= visibleCount; });
        more.hidden = false;
        more.addEventListener('click', () => {
          const nextCard = cards[visibleCount];
          visibleCount += 5;
          cards.forEach((card, index) => { card.hidden = index >= visibleCount; });
          if (nextCard) {
            nextCard.tabIndex = -1;
            nextCard.focus({ preventScroll: true });
          }
          more.hidden = visibleCount >= cards.length;
        });
      }
    });
  }
  initialiseHM20Reviews();
  document.addEventListener('shopify:section:load', (event) => initialiseHM20Reviews(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ii-hm20-reviews"] && !Shopify.designMode) return;
  try {
    
  function initialiseHM20Reviews(root = document) {
    root.querySelectorAll('[data-ii-hm20-reviews]').forEach((section) => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const writer = section.querySelector('.ii-hm20-review-writer');
      const form = section.querySelector('.ii-hm20-review-form');
      const cards = Array.from(section.querySelectorAll('[data-review-card]'));
      const more = section.querySelector('[data-review-more]');
      const openFromLink = () => {
        if (location.hash === '#HM20ReviewForm' || (form && location.hash === '#' + form.id)) {
          writer.open = true;
          writer.scrollIntoView({ block: 'start' });
        }
      };
      openFromLink();
      window.addEventListener('hashchange', openFromLink);
      if (section.querySelector('[data-review-result]') && writer.open) {
        section.querySelector('[data-review-result]').focus({ preventScroll: true });
      }
      if (form) form.addEventListener('invalid', () => { writer.open = true; }, true);
      if (more) {
        let visibleCount = 5;
        cards.forEach((card, index) => { card.hidden = index >= visibleCount; });
        more.hidden = false;
        more.addEventListener('click', () => {
          const nextCard = cards[visibleCount];
          visibleCount += 5;
          cards.forEach((card, index) => { card.hidden = index >= visibleCount; });
          if (nextCard) {
            nextCard.tabIndex = -1;
            nextCard.focus({ preventScroll: true });
          }
          more.hidden = visibleCount >= cards.length;
        });
      }
    });
  }
  initialiseHM20Reviews();
  document.addEventListener('shopify:section:load', (event) => initialiseHM20Reviews(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    const headerEl = document.querySelector('header-section[data-cart-type]');
    const cartType = headerEl ? headerEl.getAttribute('data-cart-type') : undefined;
    if (cartType !== 'page') {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', async (event) => {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart?sections=cart-ajax`, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      const sections = await response.json();
      const state = { sections };

      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: {
            product: state,
          },
        })
      );

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: {
            cart: state,
          },
        })
      );
    } catch (e) {
      console.warn('Failed to load cart sections after add:', e);
    }
  });

  document.addEventListener('product-form:message:success', (event) => event.preventDefault());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-thoughts-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-home-reading]').forEach((section) => {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const track = section.querySelector('.home-reading__track');
    if (!track || !track.firstElementChild) return;
    const controls = section.querySelector('.home-reading__controls');
    const previous = section.querySelector('[data-reading-prev]');
    const next = section.querySelector('[data-reading-next]');
    const update = () => {
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    controls.hidden = false;
    const move = (direction) => {
      const step = track.firstElementChild.getBoundingClientRect().width + 14;
      track.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    };
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', update, { passive: true });
    new ResizeObserver(update).observe(track);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prayer-mats-collection-guide"] && !Shopify.designMode) return;
  try {
    
  class PrayerMatsSale extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-prayer-tab]'))
      this.panels = Array.from(this.querySelectorAll('[data-prayer-panel]'))

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activateTab(index))
        tab.addEventListener('keydown', (event) => this.onTabKeydown(event, index))
      })

      this.addEventListener('submit', (event) => {
        const form = event.target.closest('[data-prayer-add-form]')
        if (!form) return
        this.onAddSubmit(event, form)
      })
    }

    activateTab(index, moveFocus = false) {
      const nextTab = this.tabs[index]
      if (!nextTab) return

      this.tabs.forEach((tab) => {
        const selected = tab === nextTab
        tab.setAttribute('aria-selected', selected ? 'true' : 'false')
        tab.tabIndex = selected ? 0 : -1
      })

      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.prayerPanel !== nextTab.dataset.prayerTab
      })

      if (moveFocus) nextTab.focus()
    }

    onTabKeydown(event, index) {
      let nextIndex = null

      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        nextIndex = (index + 1) % this.tabs.length
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        nextIndex = (index - 1 + this.tabs.length) % this.tabs.length
      } else if (event.key === 'Home') {
        nextIndex = 0
      } else if (event.key === 'End') {
        nextIndex = this.tabs.length - 1
      }

      if (nextIndex === null) return
      event.preventDefault()
      this.activateTab(nextIndex, true)
    }

    async onAddSubmit(event, form) {
      event.preventDefault()
      const button = form.querySelector('[data-prayer-add]')
      const status = form.querySelector('[data-prayer-add-status]')
      button.disabled = true
      this.setButtonLabel(button, 'Adding...')

      try {
        const addResponse = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: new FormData(form)
        })
        const addedItem = await addResponse.json()
        if (!addResponse.ok) throw addedItem

        this.setButtonLabel(button, 'Added to basket')
        if (status) status.textContent = 'Added to basket.'

        const response = await fetch(`${window.Shopify.routes.root}cart?sections=cart-ajax`, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
        const sections = await response.json()
        const state = { sections }

        document.dispatchEvent(
          new CustomEvent('ajaxProduct:added', {
            bubbles: true,
            detail: { product: state, item: addedItem }
          })
        )

        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            bubbles: true,
            detail: { cart: state }
          })
        )
      } catch (error) {
        this.setButtonLabel(button, 'Please try again')
        if (status) status.textContent = error.description || error.message || 'This item could not be added.'
        console.warn('Failed to add the selected prayer mat.', error)
      }

      window.setTimeout(() => {
        button.disabled = false
        this.setButtonLabel(button, button.dataset.defaultLabel || 'Add to basket')
      }, 1800)
    }

    setButtonLabel(button, label) {
      if (!button) return
      const labelNode = button.querySelector('[data-prayer-add-label]')
      if (labelNode) labelNode.textContent = label
    }
  }

  if (!customElements.get('prayer-mats-sale')) {
    customElements.define('prayer-mats-sale', PrayerMatsSale)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  function initialiseProductReviews(root = document) {
    root.querySelectorAll('[data-ii-reviews]').forEach((section) => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const writer = section.querySelector('.ii-review-writer');
      const form = section.querySelector('.ii-review-form');
      const cards = Array.from(section.querySelectorAll('[data-review-card]'));
      const more = section.querySelector('[data-review-more]');
      const openFromLink = () => {
        if (location.hash === '#ReviewForm' || (form && location.hash === '#' + form.id)) {
          writer.open = true;
          writer.scrollIntoView({ block: 'start' });
        }
      };
      openFromLink();
      window.addEventListener('hashchange', openFromLink);
      if (section.querySelector('[data-review-result]') && writer.open) {
        section.querySelector('[data-review-result]').focus({ preventScroll: true });
      }
      if (form) form.addEventListener('invalid', () => { writer.open = true; }, true);
      if (more) {
        let visibleCount = 5;
        cards.forEach((card, index) => { card.hidden = index >= visibleCount; });
        more.hidden = false;
        more.addEventListener('click', () => {
          const nextCard = cards[visibleCount];
          visibleCount += 5;
          cards.forEach((card, index) => { card.hidden = index >= visibleCount; });
          if (nextCard) {
            nextCard.tabIndex = -1;
            nextCard.focus({ preventScroll: true });
          }
          more.hidden = visibleCount >= cards.length;
        });
      }
    });
  }
  initialiseProductReviews();
  document.addEventListener('shopify:section:load', (event) => initialiseProductReviews(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whatsapp-human-support"]) return;
  try {
    
  class WhatsAppHumanSupport extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.positionSupport();
        });
      };
      const options = { passive: true, signal: this.abortController.signal };
      window.addEventListener('scroll', this.schedule, options);
      window.addEventListener('resize', this.schedule, options);
      window.visualViewport?.addEventListener('resize', this.schedule, options);
      window.visualViewport?.addEventListener('scroll', this.schedule, options);
      this.resizeObserver = new ResizeObserver(this.schedule);
      this.resizeObserver.observe(document.body);
      this.schedule();
    }

    disconnectedCallback() {
      this.abortController.abort();
      this.resizeObserver.disconnect();
      cancelAnimationFrame(this.frame);
    }

    positionSupport() {
      this.style.setProperty('--ii-wa-lift', '0px');
      const box = this.getBoundingClientRect();
      const viewport = window.visualViewport;
      const viewportBottom = viewport ? Math.min(window.innerHeight, viewport.offsetTop + viewport.height) : window.innerHeight;
      let top = Math.min(box.top, viewportBottom - (window.innerHeight - box.bottom) - box.height);
      const controls = [...document.querySelectorAll('.add-to-cart, .quick-add-btn, .shopify-payment-button')]
        .filter(control => getComputedStyle(control).visibility !== 'hidden')
        .map(control => control.getBoundingClientRect())
        .filter(rect => rect.width > 0 && rect.height > 0 && rect.right > box.left && rect.left < box.right && rect.bottom > 0 && rect.top < viewportBottom)
        .sort((a, b) => b.bottom - a.bottom);

      for (const rect of controls) {
        if (top < rect.bottom + 8 && top + box.height > rect.top - 8) {
          top = rect.top - box.height - 8;
        }
      }
      const lift = Math.ceil(Math.max(0, box.top - Math.max(16, top)));
      this.style.setProperty('--ii-wa-lift', `${lift}px`);
    }
  }

  customElements.define('whatsapp-human-support', WhatsAppHumanSupport);

  } catch(e) { console.error(e); }
})();
})();
